export const BTN_VARIANT_PROPS = [
  'primary',
  'secondary',
  'tertiary',
  'naked',
  'naked-black',
  'naked-danger',
  'danger',
  'danger-outline',
  'cta',
  'topup', // to be deprecated. use cta
  'grey-outlined', // to be deprecated. use secondary-outlined
];

export const BTN_SIZE_PROPS = ['xs', 'sm', 'md', 'lg', 'xl'];
